/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon20Solid = forwardRef('TextBulletIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4 6.498a1.498 1.498 0 1 0 0-2.996 1.498 1.498 0 0 0 0 2.996Z" }),
        React.createElement("path", { d: "M7 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M8 9a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H8Z" }),
        React.createElement("path", { d: "M8 14a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H8Z" }),
        React.createElement("path", { d: "M4 16.502a1.499 1.499 0 1 0 0-2.997 1.499 1.499 0 0 0 0 2.997Z" }),
        React.createElement("path", { d: "M5.498 10.002a1.498 1.498 0 1 1-2.996 0 1.498 1.498 0 0 1 2.996 0Z" })));
});
